import { User } from "@privy-io/react-auth";
import { AssetType } from "types";
import { REACT_APP_ENV } from "env";

export const formatToDollarTradeDollarShare = (amountString: string): string => {
  // Convert the string to a number
  const amount = parseFloat(amountString);

  // Check if the parsed number is valid
  if (isNaN(amount)) {
    return "0";
  }
  if (amount < 0) return "N/A";

  return amount.toLocaleString("en-US", { style: "currency", currency: "USD" });
};

export const formatToDollar = (amountString: string): string => {
  // Convert the string to a number
  const amount = parseFloat(amountString);

  // Check if the parsed number is valid
  if (isNaN(amount)) {
    return "0";
  }
  if (amount < 0) return "N/A";

  return amount.toLocaleString("en-US", { style: "currency", currency: "USD" });
};
export const formatToDollarProfile = (amountString: string): string => {
  // Convert the string to a number
  const amount = parseFloat(amountString);

  // Check if the parsed number is valid
  if (isNaN(amount)) {
    return "0";
  }
  if (amount < 0) return "N/A";
  return amount.toLocaleString("en-US", { style: "currency", currency: "USD" });
};

export const formatLossOrGain = (amountString: string): string => {
  const amount = parseFloat(amountString);
  return amount.toLocaleString("en-US", { style: "currency", currency: "USD" });
};

export const getUserEmail = (user: User) => {
  if (!user) return;
  if (user.email) return user.email.address;
  if (user.google) return user.google.email;
  return;
};

export const determineAddress = (co: AssetType) => {
  if (REACT_APP_ENV == "production") return co.address;
  if (REACT_APP_ENV == "pre_production") return co.address;
  if (REACT_APP_ENV == "staging") return co.testAddress;
  return co.testAddress;
};

export const determinePoolAddress = (co: AssetType) => {
  if (REACT_APP_ENV == "production") return co.tradePools;
  if (REACT_APP_ENV == "pre_production") return co.tradePools;
  if (REACT_APP_ENV == "staging") return co.testTradePools;
  return co.testTradePools;
};

export const determineTest = () => {
  if (REACT_APP_ENV == "production") return false;
  if (REACT_APP_ENV == "pre_production") return false;
  if (REACT_APP_ENV == "staging") return true;
  return true;
};
